import type { ReactNode } from "react";
import { Card } from "../Card";
import { Skeleton } from "../Skeleton";
import { PASO_PAGE_SHELL } from "../solicitud-stepper/StepperLayout";
import { EncabezadoPaginaSkeleton } from "./EncabezadoPaginaSkeleton";
import { RegionCargando } from "./RegionCargando";

export interface WizardPasoSkeletonProps {
  /** Pasos del stepper lateral · default 7 (el wizard FB60 típico). */
  pasos?: number;
  /** Filas del contenido del paso. */
  filas?: number;
  /**
   * Contenido propio del paso (p. ej. un `FormSkeleton` en su `Card`) · reemplaza
   * la tarjeta genérica de filas y la barra de acciones.
   */
  children?: ReactNode;
}

/**
 * Paso del wizard en carga · MISMO marco que las páginas reales
 * (`PASO_PAGE_SHELL` + `LayoutConStepper`: stepper sticky en 4/3 columnas y
 * contenido en 8/9), para que al resolver el loader no salte el layout.
 */
export function WizardPasoSkeleton({ pasos = 7, filas = 5, children }: WizardPasoSkeletonProps) {
  return (
    <RegionCargando etiqueta="Cargando paso…" className="w-full px-4 py-6 md:px-6" style={PASO_PAGE_SHELL}>
      <EncabezadoPaginaSkeleton conBreadcrumbs />
      <div className="mt-4 grid grid-cols-12 gap-4" aria-hidden="true">
        <div className="col-span-12 md:col-span-4 lg:col-span-3">
          <Card padding="md">
            <div className="flex flex-col gap-6">
              {Array.from({ length: pasos }, (_, i) => (
                <div key={i} className="flex items-center gap-3">
                  <Skeleton height={30} width={30} circle className="shrink-0" />
                  <div className="flex flex-1 flex-col gap-1.5">
                    <Skeleton height={12} width={i % 2 === 0 ? "70%" : "55%"} />
                    <Skeleton height={9} width="40%" />
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
        <div className="col-span-12 flex flex-col gap-4 md:col-span-8 lg:col-span-9">
          {children ?? (
            <>
              <Skeleton height={44} className="rounded-lg" />
              <Card>
                <Skeleton height={16} width="30%" />
                <div className="mt-5 flex flex-col gap-4">
                  {Array.from({ length: filas }, (_, i) => (
                    <div key={i} className="flex items-center gap-4">
                      <Skeleton height={14} width="22%" />
                      <Skeleton height={14} className="flex-1" />
                      <Skeleton height={14} width="14%" />
                    </div>
                  ))}
                </div>
              </Card>
              <div className="flex justify-end gap-2">
                <Skeleton height={36} width={110} />
                <Skeleton height={36} width={140} />
              </div>
            </>
          )}
        </div>
      </div>
    </RegionCargando>
  );
}
